export const DEPT_YS_TYPE_OPERATION =[
    { value: 0, label: '无' },
    { value: 1, label: '洋桔梗种苗泸西' },
    { value: 2, label: '洋桔梗种苗小街' }
];